import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getFunctions } from "firebase/functions";

const firebaseConfig = {
    apiKey: "AIzaSyCMx09MrI30nG81QzEGHU_hwE0kIuFiVNY",
    authDomain: "auto-moeis.firebaseapp.com",
    databaseURL: "https://auto-moeis-default-rtdb.asia-southeast1.firebasedatabase.app",
    projectId: "auto-moeis",
    storageBucket: "auto-moeis.firebasestorage.app",
    messagingSenderId: "683368274100",
    appId: "1:683368274100:web:5c91213c1fe22ee99e1fe1"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
export const firestore = getFirestore(app);
export const functions = getFunctions(app);

export default app;
